import { useEffect, useCallback } from 'react';
import { deleteAllHistory } from '@/services/chat.service';
import { useChatStore } from '@/store/chatStore';
import { ParcoursId } from '@/lib/constants';
import { logger } from '@/lib/logger';

interface UseHistoryResetOptions {
  enabled?: boolean;
  userType?: ParcoursId;
}

export const useHistoryReset = (options: UseHistoryResetOptions = {}) => {
  const { enabled = true, userType = "citizen" } = options;
  const { setMessages } = useChatStore();

  const resetHistory = useCallback(async () => {
    try {
      logger.info('Suppression de l\'historique du chat', null, 'useHistoryReset');
      
      // Vider le store local
      setMessages([]);
      
      // Envoyer la requête de suppression au backend
      const response = await deleteAllHistory(userType);
      
      if (!response.ok) {
        logger.warn('Erreur lors de la suppression de l\'historique', { status: response.status }, 'useHistoryReset');
      } else {
        logger.info('Historique supprimé avec succès', null, 'useHistoryReset');
      }
    } catch (error) {
      logger.error('Erreur lors de la suppression de l\'historique', error, 'useHistoryReset');
      // On ne fait pas échouer l'application si la suppression échoue
    }
  }, [userType, setMessages]);

  useEffect(() => {
    if (enabled) {
      resetHistory();
    }
  }, [enabled, resetHistory]);

  return {
    resetHistory,
  };
}; 